import { Component } from "react";

class BrowserTranslateErrorCatcher extends Component<{ children: React.ReactNode }, { hasError: boolean }> {
  state = { hasError: false } // example state
  componentDidCatch(error: Error) {
    if (error.message.includes("Failed to execute")) {
      // You could put some error logging here, or set a state, whatever you like.
      this.setState({ hasError: true });
    } else {
      throw error;
    }
  }
  render() {
    return this.props.children;
  }
}

export default BrowserTranslateErrorCatcher;
